export default function scrollTo(id) {
    if (!id) {
        return null;
    }

    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
}
